<template>
  <fragment>
    <app-header title="Rail Application Version History and Change Log" />
    <validation-observer tag="div" class="container" @submit.native.prevent ref="validation">
      <div class="card mt-4">
        <div class="card-body" @submit.prevent>
          <h2 class="mb-4">Version History and Change Log Details</h2>

          <div class="mb-3">
            <validation-provider name="name" vid="name" rules="required">
              <label class="form-label">Version Name</label>
              <c-input type="text" v-model="stateName" />
              <c-help-block />
            </validation-provider>
          </div>

          <div class="row mb-3">
            <validation-provider tag="div" class="col-lg-6 mb-3" name="released_at" vid="released_at" rules="required" v-slot="{ failed }">
              <label>Released At</label>
              <c-date v-model="stateReleasedAt" placeholder="" :class="{ 'is-invalid': failed }"/>
              <c-help-block/>
            </validation-provider>

            <validation-provider tag="div" class="col-lg-6 mb-3" name="released_at" vid="released_at" rules="required">
              <label class="form-label">Status</label>
              <c-input
                as="multiselect"
                v-model="status"
                placeholder
                :options="statusOptions"
                :preselect-first="true"
                :show-labels="false"
                :allow-empty="false"
                label="label"
                track-by="value"
              />
              <c-help-block/>
            </validation-provider>
          </div>

          <div class="mb-3">
            <validation-provider name="content" vid="content" rules="required">
              <label class="form-label">Content</label>
              <input-quill v-model="deltaValue" format="delta" :has-token="false"/>
              <c-help-block />
            </validation-provider>
          </div>

          <div v-if="$can('write integrations')" class="hstack mt-4">
            <router-link :to="{ name: 'settings.rail-app-release' }" class="btn btn-outline-primary me-auto">
              Cancel
            </router-link>

            <c-button type="submit" @click="save" validate>
              Create change log
            </c-button>
          </div>
        </div>
      </div>
    </validation-observer>
  </fragment>
</template>
<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/rail-app-releases'
import InputQuill from '@/components/forms/InputQuill'
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

export default {
  mixins: [
    stateMapper
  ],

  components: {
    InputQuill
  },

  data () {
    return {
      statusOptions: [
        { label: 'Current', value: 'current' },
        { label: 'Testing', value: 'testing' },
        { label: 'Legacy', value: 'legacy' }
      ]
    }
  },

  beforeDestroy () {
    this.resetRailAppRelease()
  },

  computed: {
    ...helperComputed,

    deltaValue: {
      get () {
        return {
          ops: []
        }
      },
      set (value) {
        this.stateContent = value
      }
    },

    status: {
      get () {
        return this.statusOptions.find(({ value }) => value === this.stateStatus)
      },

      set ({ value }) {
        this.stateStatus = value
      }
    },
  },

  methods: {
    ...helperMethods,

    convertDeltaToHtml (deltaOps) {
      const converter = new QuillDeltaToHtmlConverter(deltaOps, {})
      return converter.convert()
    },

    encodeDeltaNewlines (delta) {
      if (!delta || !Array.isArray(delta.ops)) return delta

      return {
        ...delta,
        ops: delta.ops.map(op => {
          if (op && typeof op.insert === 'string' && op.insert.startsWith('\n')) {
            const match = op.insert.match(/^\n+/)
            const newlineCount = match[0].length

            return {
              ...op,
              insert: 'NEWLINE'.repeat(newlineCount) + op.insert.slice(newlineCount)
            }
          }
          return op
        })
      }
    },

    async save () {
      const payload = {
        name: this.stateName,
        content: this.encodeDeltaNewlines(this.stateContent),
        html_content: this.convertDeltaToHtml(this.stateContent.ops),
        status: this.stateStatus,
        released_at: this.stateReleasedAt
      }

      await this.storeRailAppRelease(payload)
      await this.$router.replace({ name: 'settings.rail-app-release' })
    }
  }
}
</script>
